import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export function MerchantsPage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/merchant/directory").then((r) => setRows(r.data.merchants)).catch(() => {}); }, []);
  const filtered = rows.filter((r) => r.merchant_name.toLowerCase().includes(q.toLowerCase()));
  const totalVol = rows.reduce((s, r) => s + r.volume, 0);
  return (
    <div className="min-h-screen text-white">
      <PublicNav label="MERCHANT DIRECTORY"/>
      <section className="max-w-6xl mx-auto px-6 py-16">
        <div className="chip cyan mb-4">◆ PUBLIC · LIVE</div>
        <h1 className="font-display text-5xl md:text-6xl leading-tight">Every shop taking <span className="italic text-[#d4af37]">BlackStar</span>.</h1>
        <div className="mt-6 grid md:grid-cols-3 gap-4">
          <div className="panel p-5"><div className="label">Merchants live</div><div className="font-display text-3xl mt-2 text-[#d4af37]" data-testid="dir-count">{rows.length}</div></div>
          <div className="panel p-5"><div className="label">Total settled volume</div><div className="font-display text-3xl mt-2 text-[#39ff14]">${totalVol.toLocaleString(undefined, {maximumFractionDigits: 2})}</div></div>
          <div className="panel p-5"><div className="label">Search</div><input data-testid="dir-search" className="input mt-2" placeholder="Filter merchants…" value={q} onChange={(e)=>setQ(e.target.value)}/></div>
        </div>
        <div className="panel mt-8">
          {filtered.length === 0 && <div className="p-8 text-white/50 text-sm">No merchants yet. Be the first — see /developers for the two-line snippet.</div>}
          {filtered.map((r, i) => (
            <div key={r.merchant_name} className="flex items-center justify-between px-6 py-4 border-b border-white/5" data-testid={`dir-row-${i}`}>
              <div>
                <div className="font-display text-xl">{r.merchant_name}</div>
                <div className="text-xs font-mono text-white/40 mt-1">{r.sessions} session{r.sessions>1?"s":""} · last {r.last_paid_at ? new Date(r.last_paid_at).toLocaleDateString() : "—"}</div>
              </div>
              <div className="text-right">
                <div className="font-mono text-[#d4af37]">${r.volume.toLocaleString(undefined, {maximumFractionDigits: 2})}</div>
                <div className="text-[10px] text-[#39ff14] font-mono">SETTLED</div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <PublicFooter/>
    </div>
  );
}

export function DevelopersPage() { return null; }

function PublicNav({ label }) {
  return (
    <nav className="glass sticky top-0 z-40 border-b border-white/10">
      <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center gap-2" data-testid="pub-nav-logo">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#d4af37] to-[#7a5f16] grid place-items-center font-display font-black text-black">★</div>
          <div className="leading-none">
            <div className="font-display text-lg font-bold">BlackStar</div>
            <div className="font-mono text-[10px] tracking-[0.3em] text-white/60">{label}</div>
          </div>
        </Link>
        <div className="flex items-center gap-4 text-sm text-white/70">
          <Link to="/status" className="link-underline">Status</Link>
          <Link to="/merchants" className="link-underline">Merchants</Link>
        </div>
      </div>
    </nav>
  );
}
function PublicFooter() {
  return <footer className="border-t border-white/10 py-8 mt-6 text-center text-xs text-white/40 font-mono">© 2026 BlackStar Virtual Mint</footer>;
}
